// Reporte de errores del navegador (tarea 5.5).
//
// Por que existe: hasta hoy un error de JavaScript en el navegador de un cliente era
// **invisible**. El backend emite JSON estructurado por pino y se ve con `docker logs`, pero
// del lado del cliente no habia nada: los fallos se descubrian cuando alguien reclamaba. El
// bug de las renovaciones de sesion concurrentes (2 ago 2026) vivio en produccion sin que
// nadie lo viera, y se encontro leyendo logs del servidor por casualidad.
//
// ---------------------------------------------------------------------------
// Por que el SDK va en el bundle y NO el script del CDN que ofrece Sentry
// ---------------------------------------------------------------------------
//
// Sentry propone un "loader script" desde `js-de.sentry-cdn.com`. Aca eso esta descartado por
// dos motivos, y el segundo es el que manda:
//
//   1. La CSP de los sitios permite `script-src 'self'`. Un script de otro origen no se
//      ejecutaria, asi que no reportaria nada.
//   2. **La tarea 4.13 saco Google Fonts y jsDelivr de estos sitios** porque cada visita le
//      entregaba la IP del cliente a un tercero, y se resolvio eliminando la transferencia en
//      vez de justificarla. Meter un CDN nuevo desharia justo eso.
//
// Instalado con `npm --save`, Vite lo empaqueta en nuestro propio `/assets/`, con hash de
// contenido y servido desde nuestro dominio. La unica salida a Sentry es el POST del reporte.
//
// ---------------------------------------------------------------------------
// Que se manda y que no
// ---------------------------------------------------------------------------
//
// Sentry sigue siendo un tercero que recibe datos, asi que la configuracion es la minima que
// resuelve el problema:
//
//   - `sendDefaultPii: false` — no manda IP ni cabeceras de la peticion.
//   - Sin `Replay` ni `BrowserTracing` — nada de grabar la sesion ni medir rendimiento. Eso
//     multiplicaria el dato enviado para responder una pregunta que nadie hizo.
//   - `beforeSend` borra la query string de la URL: ahi es donde se cuelan tokens y correos.
//   - Region **UE** (`ingest.de.sentry.io`), que es la que se eligio al crear la cuenta.
//
// El DSN es publico por diseno: viaja en el bundle que cualquiera puede leer, y solo sirve
// para ENVIAR eventos, no para leerlos. Por eso esta en el codigo y no en un `.env`.
//
// Anotado en docs/legal/REGISTRO-ACTIVIDADES-TRATAMIENTO.md, que es la condicion con la que
// entra: un tercero nuevo que recibe datos se registra en el mismo cambio.

import * as Sentry from '@sentry/browser';

const DSN = 'https://a17c4988b662ecee68055153395462d4@o4511839930417152.ingest.de.sentry.io/4511839934677072';

/**
 * @param {string} area  'portal' o 'panel', para poder separarlos en Sentry.
 */
export function iniciarReporteDeErrores(area) {
  // En desarrollo no se reporta: llenaria el proyecto de ruido de una consola local y
  // gastaria la cuota gratuita en errores que ya se ven en la pantalla de al lado.
  if (location.hostname === 'localhost' || location.hostname === '127.0.0.1') return;

  try {
    Sentry.init({
      dsn: DSN,
      environment: area,
      sendDefaultPii: false,
      // Sin muestreo de rendimiento: solo errores.
      tracesSampleRate: 0,
      beforeSend(evento) {
        // La query string es donde aparecen tokens, codigos de recuperacion y correos.
        // Se corta antes de salir del navegador, no del lado de Sentry.
        if (evento.request?.url) evento.request.url = evento.request.url.split('?')[0];
        return evento;
      },
    });
  } catch {
    // Que falle el reporte de errores no puede romper la pantalla. Si Sentry no arranca, el
    // portal tiene que seguir funcionando igual: es observabilidad, no una dependencia.
  }
}
